export default __webpack_public_path__ + "static/media/content_tab03_3_02.f604fd54.png";